<template>
  <nav class="flex items-center flex-wrap bg-teal-600 h-16 px-4 fixed top-0 left-0 right-0 text-teal-200 z-20">
    <router-link class="text-base mr-4" exact-active-class="active" to="/">NER</router-link>
    <router-link class="text-base mr-4" exact-active-class="active" to="/coref">CoRef</router-link>
    <router-link class="text-base mr-4" exact-active-class="active" to="/relation-extraction">Relation Extraction</router-link>
    <router-link class="text-base mr-4" exact-active-class="active" to="/config">Config</router-link>
  </nav>
</template>

<script>
export default {

}
</script>

<style>
  .active {
    font-weight: 900;
    text-shadow: 1px 1px rgba(0,0,0,0.2);
    color: #fff
  }
</style>